import React from 'react';

/** Simplified rendering of the French Republic block mark (Marianne, tricolour, motto). */
const RepubliqueLogo = () => (
  <svg width="104" height="64" viewBox="0 0 104 64" role="img" aria-label="République Française" className="shrink-0">
    <rect width="104" height="64" fill="#ffffff" stroke="#1f1f1f" strokeWidth="1" />
    <rect x="14" y="10" width="18" height="22" fill="#000091" />
    <rect x="32" y="10" width="18" height="22" fill="#ffffff" stroke="#c9c9c9" strokeWidth="0.5" />
    <rect x="50" y="10" width="18" height="22" fill="#e1000f" />
    <path d="M36 30c3-6 6-9 9-9s5 3 6 6-1 4-3 5c-2-2-4-2-6-1-2-1-4-1-6-1z" fill="#000091" opacity="0.9" />
    <text x="52" y="44" textAnchor="middle" fontFamily="Georgia, serif" fontStyle="italic" fontSize="5.2" fill="#1f1f1f">Liberté • Égalité • Fraternité</text>
    <text x="52" y="54" textAnchor="middle" fontFamily="Georgia, serif" fontWeight="bold" fontSize="6.2" fill="#1f1f1f" letterSpacing="0.5">RÉPUBLIQUE FRANÇAISE</text>
  </svg>
);

/**
 * Statutory alcohol notice displayed beneath the footer on the CGV / Terms page only
 * (Code de la santé publique, art. L.3342-1 and L.3353-3).
 */
export const LegalBanner = () => (
  <aside data-testid="legal-alcohol-banner" className="bg-white text-[#1f1f1f]">
    <div className="nw-container py-6 flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-8">
      <RepubliqueLogo />
      <div className="font-sans text-[13px] leading-relaxed">
        <p>Interdiction de vente de boissons alcooliques aux mineurs de moins de 18 ans</p>
        <p>La preuve de majorité de l'acheteur est exigée au moment de la vente en ligne</p>
        <p className="mt-2">CODE DE LA SANTÉ PUBLIQUE, ART. L. 3342-1 et L. 3353-3</p>
        <p>L'abus d'alcool est dangereux pour la santé. Sachez consommer avec modération.</p>
      </div>
    </div>
  </aside>
);
